<div class="wrapper">
  <ng-container *ngIf="goBackLink">
    <a
      [routerLink]="goBackLink"
      [queryParams]="goBackQueryParams"
      class="left go-back"
    >
      <app-shared-icon
        [size]="16"
        name="arrow-left-blue"
        class="icon"
        style="margin-top: 0.7rem"
      ></app-shared-icon>
      <h1 *ngIf="!!pageTitle">
        {{ pageTitle }}
      </h1>
    </a>
  </ng-container>

  <div *ngIf="!goBackLink" class="left">
    <h1 *ngIf="!!pageTitle">
      {{ pageTitle }}
    </h1>
  </div>

  <div *ngIf="helpModal" class="help-modal">
    <app-shared-title-help [content]="helpModal"></app-shared-title-help>
  </div>
</div>

<div *ngIf="subtitle" class="subtitle" [ngClass]="{ mobile: isMobile }">
  {{ subtitle }}
</div>
